// Behavior registry for data-driven entities (Fase 3).

import type { World } from '../world';
import type { Entity } from '../entity';

export interface Behavior {
  id: string;
  onSpawn?(world: World, entity: Entity): void;
  onTick?(world: World, entity: Entity, dt: number): void;
  onHit?(world: World, entity: Entity, damage: number): void;
  onDeath?(world: World, entity: Entity): void;
}

const registry = new Map<string, Behavior>();

export function registerBehavior(b: Behavior): void {
  registry.set(b.id, b);
}

export function getBehavior(id: string): Behavior | undefined {
  return registry.get(id);
}

export function listBehaviors(): string[] {
  return [...registry.keys()];
}

export function clearBehaviors(): void {
  registry.clear();
}
